import { __assign, __extends } from "tslib";
import cx from 'classnames';
import { values } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DropTarget as dropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import { VelocityTransitionGroup } from 'velocity-react';
import * as screenLocation from '../constants/screenLocation';
import Annotation from '../containers/Annotation';
import Hotspot from '../containers/Hotspot';
import Element from '../containers/handoff/Element';
import RelativeGuides from '../containers/handoff/RelativeGuides';
import Columns from '../containers/handoff/layout/Columns';
import Rows from '../containers/handoff/layout/Rows';
import styles from './HotspotLayer.module.css';
var annotationTransitionProps = {
    leave: {
        animation: { scale: [0, 1] },
        duration: 300,
        easing: [0.175, 0.885, 0.32, 1.275],
    },
};
var HotspotLayer = /** @class */ (function (_super) {
    __extends(HotspotLayer, _super);
    function HotspotLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderHotspot = function (_a) {
            var id = _a.id;
            var _b = _this.props, getScreenScrollPos = _b.getScreenScrollPos, getOverlayScrollPos = _b.getOverlayScrollPos, location = _b.location, screenID = _b.screenID;
            return (React.createElement(Hotspot, { getOverlayScrollPos: getOverlayScrollPos, getScreenScrollPos: getScreenScrollPos, id: id, key: id, location: location, screenID: screenID }));
        };
        _this.renderAnnotation = function (annotation) {
            var _a = _this.props, location = _a.location, screenID = _a.screenID;
            var commentUUID = annotation.commentUUID, reference = annotation.reference;
            return (React.createElement(Annotation, __assign({ id: reference, key: commentUUID, location: location, screenID: screenID }, annotation)));
        };
        _this._onClick = function (e) {
            if (_this.props.isInAnnotationMode) {
                // TODO are these cross browser??
                var _a = e.nativeEvent, offsetX = _a.offsetX, offsetY = _a.offsetY;
                // ////////////////////////////////////////////////
                _this.props.onClick(_this.props.location, { x: offsetX, y: offsetY });
            }
        };
        return _this;
    }
    HotspotLayer.prototype.render = function () {
        var _a;
        var _b = this.props, height = _b.height, hotspots = _b.hotspots, annotations = _b.annotations, elements = _b.elements, isInAnnotationMode = _b.isInAnnotationMode, isInHandoffMode = _b.isInHandoffMode, areLayoutRowsEnabled = _b.areLayoutRowsEnabled, areLayoutColumnsEnabled = _b.areLayoutColumnsEnabled, connectDropTarget = _b.connectDropTarget;
        var className = cx(styles.hotspotLayer, (_a = {},
            _a[styles.annotationMode] = isInAnnotationMode,
            _a));
        var layer = (React.createElement("div", { className: className, onClick: this._onClick, style: { height: height } },
            !isInAnnotationMode &&
                !isInHandoffMode &&
                hotspots.map(this.renderHotspot),
            React.createElement(VelocityTransitionGroup, __assign({}, annotationTransitionProps), annotations.map(this.renderAnnotation)),
            elements.map(function (element) { return (React.createElement(Element, __assign({ key: element.id }, element))); }),
            React.createElement(RelativeGuides, null),
            areLayoutColumnsEnabled && React.createElement(Columns, null),
            areLayoutRowsEnabled && React.createElement(Rows, null)));
        return connectDropTarget(layer);
    };
    return HotspotLayer;
}(Component));
var hotspotLayerTarget = {
    drop: function (props, monitor, component) {
        var annotation = monitor.getItem();
        var layerPosition = findDOMNode(component).getBoundingClientRect();
        var annotationPosition = monitor.getClientOffset();
        props.positionAnnotation(annotation.commentUUID, props.location, {
            x: annotationPosition.x - layerPosition.left,
            y: annotationPosition.y - layerPosition.top,
        });
    },
};
function collect(connect) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDropTarget: connect.dropTarget(),
    };
}
HotspotLayer.propTypes = {
    height: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    location: PropTypes.oneOf(values(screenLocation)),
    hotspots: PropTypes.array,
    elements: PropTypes.array.isRequired,
    getScreenScrollPos: PropTypes.func,
    annotations: PropTypes.array.isRequired,
    isInAnnotationMode: PropTypes.bool,
    isInHandoffMode: PropTypes.bool,
    connectDropTarget: PropTypes.func.isRequired,
    areLayoutRowsEnabled: PropTypes.bool,
    areLayoutColumnsEnabled: PropTypes.bool,
    getOverlayScrollPos: PropTypes.func,
    screenID: PropTypes.number.isRequired,
};
HotspotLayer.defaultProps = {
    hotspots: [],
    elements: [],
    annotations: [],
};
export default dropTarget('annotation', hotspotLayerTarget, collect)(HotspotLayer);
